module.exports = __webpack_public_path__ + "img/landing-txt.6460c532.png";